import { createRoot } from 'react-dom/client';
import { RecurringDonationLanding } from './RecurringDonationLanding.tsx';

interface QsParamInfo {
    highDefaultValues: boolean,
    initialCustomAmount?: number,
}

/**
 * Pulls some values out of the query-string. The mid-level giving team chose the exact abbreviations to use (hence the
 * abbreviations). `ttd` means "tip-top donor".
 */
const parseQsParam = (): QsParamInfo  => {
    let result: QsParamInfo = { highDefaultValues: false };

    if (window.qsParam['ttd'] == 'true') {
        result.highDefaultValues = true;
    }
    if (window.qsParam['amount']) {
        result.initialCustomAmount = parseInt(window.qsParam['amount'], 10);
    }

    return result;
}

$(() => {
    const parameters = parseQsParam();

    const contentDOM = document.getElementById('content')!;
    const root = createRoot(contentDOM);
    root.render(
        <RecurringDonationLanding
            highDefaultValues={parameters.highDefaultValues}
            initialCustomAmount={parameters.initialCustomAmount}
        />);
});
